import React from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import { images } from 'config';
import { Container } from 'components/styled/ui';
import { media } from 'components/styled/utils';

const PageNotFound = () => (
  <Content>
    <Container>
      <img className="logo" src={images.susasanLogoBlue} alt="Susasan" />
      <h2>पृष्ठ भेटिएन</h2>
      <img className="page-not-found" src={images.pageNotFound} alt="" />
      <NavLink to="/">
        मुख्य पृष्ठ फर्कनुहोश
        <img src={images.icons.forwardBlue} alt="Forward" />
      </NavLink>
    </Container>
  </Content>
);

export default PageNotFound;

const Content = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;

  > div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .logo,
    h2,
    .page-not-found {
      margin-bottom: 24px;

      ${media.sm`
                margin-bottom: 68px;
            `};
    }

    .page-not-found {
      max-width: 100%;
    }

    h2 {
      color: #666e76;
      font-size: 48px;
    }

    > a {
      color: #028eff;
      font-size: 24px;
      > img {
        display: inline-block;
        margin-left: 6px;
        vertical-align: middle;
        transition: all 0.2s ease-in;
      }

      &:hover {
        img {
          transform: translateX(2px);
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/pageNotFound/pageNotFound.js